import { Body, Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, getManager } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Donors } from './donor.entity';
import { DonorsDTO } from './dto/donor.dto';
import { AllDonorsResponseModel, DonorsResponseModel } from '@gtpl/shared-models/gtpl';
import { DonorAdapter } from './dto/donor.adapter';
import { DistrictReq } from './dto/distirct-req';

@Injectable()
export class DonorService {
    constructor(
        @InjectRepository(Donors)
        private donorsRepository: Repository<Donors>,
        private donorsAdapter: DonorAdapter,
    ){}

    async getDonorsWithoutRelations(donorsName: string): Promise<Donors> {
        // tslint:disable-next-line: typedef
        const donorsResponse = await this.donorsRepository.findOne({
          where: {donorsName: Raw(alias => `donor_name = '${donorsName}'`)},
        });
        if (donorsResponse) {
          return donorsResponse;
        } else {
          return null;
        }
      }

      async createDonors(donorsDto: DonorsDTO, isUpdate: boolean): Promise<DonorsResponseModel> {
        console.log(donorsDto);
        try {
          console.log(isUpdate);
          // if (!isUpdate) {
          //   const DonorsEntity = await this.getDonorsWithoutRelations(donorsDto.donorName);
          //   if (DonorsEntity) {
          //     //return new InformationMessageError(11104, "State already exists");
          //     throw new DonorsResponseModel(false,11104, 'Donor Name already exists');
          //   }
          // }
          // else{
          //   const DonorsEntity = await this.getDonorsWithoutRelations(donorsDto.donorName);
          //   if (DonorsEntity) {
          //     if(DonorsEntity.donorsId!=donorsDto.donorsId) {
          //       throw new DonorsResponseModel(false,11104, 'Donor already exists');      
          //     }
          //   }
          // }
          const convertedDonorsEntity: Donors = this.donorsAdapter.convertDtoToEntity(donorsDto,isUpdate);
          console.log(convertedDonorsEntity,'1')
          const savedDonorsEntity: Donors = await this.donorsRepository.save(
            convertedDonorsEntity
          );
          console.log(savedDonorsEntity,'2')
          const savedDonorsDto: DonorsDTO = this.donorsAdapter.convertEntityToDto(convertedDonorsEntity);
          console.log(savedDonorsDto,'3');
          if (savedDonorsDto) {
            // generating response
            const response = new DonorsResponseModel(true,1,isUpdate? 'Donors Updated Successfully': 'Donor Created Successfully')
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new DonorsResponseModel(false,11106,'Donors saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          return error;
        }
      } 
      
      async getAllDonors() : Promise<AllDonorsResponseModel>{
        try {
            const DonorsDto : DonorsDTO[] = []
            const DonorsEntity : Donors[] = await this.donorsRepository.find({order :{'donorName':'ASC'}});
            if (DonorsEntity) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                DonorsEntity.forEach(DonorsEntity => {
                 const convertedDonorsDto: DonorsDTO = this.donorsAdapter.convertEntityToDto(
                    DonorsEntity
                 );
                 DonorsDto.push(convertedDonorsDto);
               });
               const response = new AllDonorsResponseModel(true,1,'Donors retrieved successfully',DonorsDto);
               //generated response
               return response
             } else {
               throw new DonorsResponseModel(false,99998, 'Data not found');
             }
        } catch (error) {
            
        }
      } 

      async getConstituencyForDistirct(req:DistrictReq){
        const manager = getManager()
        const query = "select constituencies as constituency from `finance`.`constituencies` c where c.state = '" + req.state  +"'and c.district = '" + req.district + "'" 
        const data = await manager.query(query)
        return data
       }
    }

